// Contracts Page - Стиль как у Публикаций (Креативов)
import React, { useState, useEffect } from 'react';
import api from '../services/api';
import SyncButton from './SyncButton';
import './ContractsPage.css';

const ContractsPage = () => {
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [syncing, setSyncing] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedContracts, setSelectedContracts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  
  const [showModal, setShowModal] = useState(false);  
  const [modalMode, setModalMode] = useState("view"); // "view", "add", "edit"  
  const [selectedContract, setSelectedContract] = useState(null);
  const [loadingContract, setLoadingContract] = useState(false); // Индикатор загрузки договора

  useEffect(() => {
    loadContracts();
  }, []);

  const loadContracts = async () => {
    try {
      const res = await api.get('/contracts/');
      setContracts(res.data || []);
    } catch (error) {
      console.error('Ошибка загрузки договоров:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSync = async () => {
    setSyncing(true);
    try {
      // Получаем реальный user_id из localStorage
      const userData = localStorage.getItem('user_data');
      const userId = userData ? JSON.parse(userData).id : 1;
      
      
      const res = await api.post(`/contracts/sync-from-vk-ord?user_id=${userId}`);
      alert(`✅ ${res.data.message || 'Синхронизировано ' + res.data.synced_count + ' договоров'}`);
      await loadContracts();
    } catch (error) {
      alert(`❌ Ошибка синхронизации: ${error.message}`);
    } finally {
      setSyncing(false);
    }
  };

  const handleAdd = () => {    setSelectedContract(null);    setModalMode("add");    setShowModal(true);  };
  
  const handleView = async (contract) => {
    try {
      // Загружаем актуальные данные из VK ORД
      const vkResponse = await api.get(`/contracts/vk-ord/${contract.external_id}`);
      const vkData = vkResponse.data;
      
      // Формируем данные для обновления локальной БД
      const updatedData = {
        type: vkData.type,
        client_external_id: vkData.client_external_id,
        contractor_external_id: vkData.contractor_external_id,
        date: vkData.date,
        serial: vkData.serial,
        subject_type: vkData.subject_type,
        action_type: vkData.action_type,
        amount: vkData.amount,
        flags: vkData.flags || [],
        parent_contract_external_id: vkData.parent_contract_external_id,
        comment: vkData.comment,
        end_date: vkData.date_end  // VK ORD использует date_end!
      };
      
      // Сохраняем актуальные данные в локальную БД
      await api.put(`/contracts/detail-ext/${contract.external_id}`, updatedData);
      
      // Обновляем список договоров
      await loadContracts();
      
      // Открываем модальное окно с обновленными данными
      const updatedContract = { ...contract, ...vkData };
      setSelectedContract(updatedContract);
      setModalMode("view");
      setShowModal(true);
    } catch (error) {
      console.error('Ошибка загрузки данных из VK ORД:', error);
      // Если ошибка - открываем с текущими данными
      setSelectedContract(contract);
      setModalMode("view");
      setShowModal(true);
    }
  };
  
  const handleEdit = async (contract) => {
    // Сразу открываем модальное окно с индикатором загрузки
    setLoadingContract(true);
    setSelectedContract(null); // Очищаем данные
    setModalMode("edit");
    setShowModal(true);
    
    const loadingStartTime = Date.now();
    
    // Даем React время отрендерить индикатор загрузки
    await new Promise(resolve => setTimeout(resolve, 300));
    
    try {
      // Загружаем актуальные данные из VK ОРД (теперь также обновляет статус ЕРИР в БД)
      const vkResponse = await api.get(`/contracts/vk-ord/${contract.external_id}`);
      const vkData = vkResponse.data;
      
      // Обновляем список договоров (чтобы увидеть обновлённый статус ЕРИР)
      await loadContracts();
      
      // Гарантируем минимальное время показа индикатора загрузки (500ms)
      const minLoadingTime = 500;
      const elapsed = Date.now() - loadingStartTime;
      const remainingTime = Math.max(0, minLoadingTime - elapsed);
      if (remainingTime > 0) {
        await new Promise(resolve => setTimeout(resolve, remainingTime));
      }
      
      // Устанавливаем данные договора и убираем индикатор
      setSelectedContract(vkData);
      setLoadingContract(false);
    } catch (error) {
      console.error('Ошибка загрузки данных из VK ОРД:', error);
      // При ошибке также убираем индикатор и закрываем модальное окно
      setLoadingContract(false);
      setShowModal(false);
      alert(`❌ Ошибка загрузки данных договора: ${error.message}`);
    }
  };
  const handleDelete = async (contractId) => {
    if (!window.confirm("Удалить договор?")) return;
    try {
      const response = await fetch(`/contracts/${contractId}`, { 
        method: "DELETE" 
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.detail || 'Ошибка удаления');
      }
      
      alert("✅ Договор удалён");
      await loadContracts();
    } catch (error) {
      alert(`❌ Ошибка: ${error.message}`);
    }
  };
  const handleSaveContract = async (contractData) => {
    try {
      if (modalMode === "edit") {
        // ВАЖНО: используем external_id вместо id для обновления
        await api.put(`/contracts/detail-ext/${selectedContract.external_id}`, contractData);
      } else {
        await api.post('/contracts/', contractData);
      }
      alert(`✅ Договор ${modalMode === "edit" ? "обновлен" : "создан"}`);
      setShowModal(false);
      await loadContracts();
    } catch (error) {
      alert(`❌ Ошибка: ${error.message}`);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${day}.${month}.${year}`;
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount) + ' ₽';
  };

  const getTypeLabel = (type) => {
    const types = {
      'service': 'Оказание услуг',
      'mediation': 'Посредничество',
      'additional': 'Доп. соглашение'
    };
    return types[type] || type;
  };

  const getSubjectLabel = (subject) => {
    const subjects = {
      'distribution': 'Распространение',
      'org_distribution': 'Орг. распространение',
      'mediation': 'Посредничество'
    };
    return subjects[subject] || subject;
  };

  const getErirStatusLabel = (state) => {
    if (!state) return 'Статус неизвестен';
    
    const normalized = state.toLowerCase();
    const statusMap = {
      'verified': 'Принято в ЕРИР',
      'accepted': 'Принято в ЕРИР',
      'registered': 'Принято в ЕРИР',
      'processing': 'В обработке',
      'pending': 'Отправлено',
      'submitted': 'Отправлено',
      'sent': 'Отправлено',
      'waiting': 'Ожидает документы',
      'waiting_documents': 'Ожидает документы',
      'rejected': 'Отклонено',
      'declined': 'Отклонено',
      'error': 'Ошибка',
      'failed': 'Ошибка'
    };
    
    return statusMap[normalized] || state;
  };

  const getErirStatusClass = (state) => {
    if (!state) return 'status-unknown';
    
    const normalized = state.toLowerCase();
    const successStates = ['verified', 'accepted', 'registered'];
    const warningStates = ['processing', 'pending', 'submitted', 'sent', 'waiting', 'waiting_documents'];
    const dangerStates = ['rejected', 'declined', 'error', 'failed'];
    
    if (successStates.includes(normalized)) return 'status-success';
    if (warningStates.includes(normalized)) return 'status-warning';
    if (dangerStates.includes(normalized)) return 'status-danger';
    return 'status-neutral';
  };

  const toggleSelectAll = () => {
    if (selectedContracts.length === contracts.length) {
      setSelectedContracts([]);
    } else {
      setSelectedContracts(contracts.map(c => c.external_id));
    }
  };

  const toggleSelect = (id) => {
    if (selectedContracts.includes(id)) {
      setSelectedContracts(selectedContracts.filter(cid => cid !== id));
    } else {
      setSelectedContracts([...selectedContracts, id]);
    }
  };
  // Фильтрация договоров по поисковому запросу
  const filteredContracts = contracts.filter(contract => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    return (
      contract.serial?.toLowerCase().includes(query) ||
      contract.external_id?.toLowerCase().includes(query) ||
      contract.type?.toLowerCase().includes(query) ||
      contract.subject_type?.toLowerCase().includes(query) ||
      contract.client_external_id?.toLowerCase().includes(query) ||
      contract.contractor_external_id?.toLowerCase().includes(query) ||
      contract.comment?.toLowerCase().includes(query)
    );
  });


  const totalPages = Math.ceil(filteredContracts.length / perPage);
  const startIndex = (currentPage - 1) * perPage;
  const displayedContracts = filteredContracts.slice(startIndex, startIndex + perPage);

  if (loading) {
    return (
      <div className="contracts-page">
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p style={{marginTop: '16px', color: '#586069'}}>Загрузка договоров...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="contracts-page">
      {/* Header */}
      {/* Search */}
      <div className="table-controls">
        <div className="search-bar">
          <input
            type="text"
            placeholder="🔍 Поиск по договорам..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
            className="search-input"
          />
          {searchQuery && (
            <button 
              className="clear-search"
              onClick={() => setSearchQuery("")}
            >
              ✕
            </button>
          )}
        </div>
        <div className="table-options">
          <button 
            className="add-button"
            onClick={() => { setModalMode('add'); setSelectedContract(null); setShowModal(true); }}
          >
            ➕ Добавить договор
          </button>
          <SyncButton 
            customHandler={handleSync} 
            onSyncComplete={loadContracts}
            tooltipText="Синхронизировать договоры с VK ORД"
          />
        </div>
      </div>

      {/* Table */}
      {displayedContracts.length > 0 ? (
        <div className="contracts-table">
          <table>
            <thead>
              <tr>
                <th className="contract-number-header">№ ДОГОВОРА</th>
                <th className="type-header">ТИП</th>
                <th className="date-header">ДАТА ЗАКЛЮЧЕНИЯ</th>
                <th className="amount-header">СУММА</th>
                <th className="status-header">СТАТУС</th>
                <th className="actions-header">ДЕЙСТВИЯ</th>
              </tr>
            </thead>
            <tbody>
              {displayedContracts.map((contract) => (
                <tr key={contract.external_id}>
                  <td className="contract-number-cell">
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                      <a 
                        href="#" 
                        className="erid-link"
                        onClick={(e) => {
                          e.preventDefault();
                          handleEdit(contract);
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        № {contract.serial}
                      </a>
                      {contract.comment && (
                        <div style={{ 
                          fontSize: '10px', 
                          color: '#586069', 
                          lineHeight: '1.4',
                          wordBreak: 'break-word',
                          maxWidth: '200px'
                        }}>
                          {contract.comment}
                        </div>
                      )}
                    </div>
                  </td>
                  <td className="type-cell">
                    <span className="form-badge">
                      {getTypeLabel(contract.type)}
                    </span>
                  </td>
                  <td className="date-cell">
                    {formatDate(contract.date)}
                  </td>
                  <td className="amount-cell">
                    <strong>{formatAmount(contract.amount)}</strong>
                  </td>
                  <td className="status-cell">
                    <span className={`status-badge ${getErirStatusClass(contract.erir_status_state)}`}>
                      {getErirStatusLabel(contract.erir_status_state)}
                    </span>
                  </td>
                  <td className="actions-cell">
                    <div className="action-buttons">
                      <button className="icon-button" title="Редактировать" onClick={() => handleEdit(contract)}>✏️</button>
                      <button className="icon-button" title="Копировать">📋</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="contracts-table">
          <div className="empty-state">
            <div className="empty-state-icon">📋</div>
            <h3>Договоры не найдены</h3>
            <p>Синхронизируйте с VK ORD или добавьте первый договор</p>
            <button className="add-button" onClick={handleSync}>
            </button>
          </div>
        </div>
      )}


      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination-bottom">
          <button 
            className="page-button"
            onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
            disabled={currentPage === 1}
          >
            ← Назад
          </button>
          <span className="page-info">
            Страница {currentPage} из {totalPages}
          </span>
          <button 
            className="page-button"
            onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
            disabled={currentPage === totalPages}
          >
            Вперёд →
          </button>
          <select 
            className="per-page-select"
            value={perPage}
            onChange={(e) => {
              setPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={20}>20 / стр.</option>
            <option value={50}>50 / стр.</option>
            <option value={100}>100 / стр.</option>
          </select>
        </div>
      )}
      {/* Модальное окно */}
      {showModal && (
        <div className="modal-overlay" onClick={() => {
          setShowModal(false);
          setLoadingContract(false);
        }}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>
                {modalMode === "view" ? "📋 Просмотр договора" :
                 modalMode === "edit" ? "✏️ Редактирование договора" :
                 "➕ Новый договор"}
              </h2>
              <button className="modal-close" onClick={() => {
                setShowModal(false);
                setLoadingContract(false);
              }}>✕</button>
            </div>
            
            <div className="modal-body">
              {loadingContract && modalMode === "edit" ? (
                <div className="loading-container" style={{ minHeight: '200px', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  <div className="loading-spinner"></div>
                  <p style={{marginTop: '16px', color: '#586069', fontSize: '14px'}}>Загрузка данных договора из VK ОРД...</p>
                </div>
              ) : modalMode === "view" ? (
                <ViewContractContent contract={selectedContract} />
              ) : (
                <EditContractForm
                  contract={selectedContract}
                  mode={modalMode}
                  onSave={handleSaveContract}
                  onCancel={() => setShowModal(false)}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContractsPage;

// Компонент просмотра договора
export const ViewContractContent = ({ contract }) => {
  if (!contract) return <p>Договор не найден</p>;
  
  return (
    <div className="contract-details">
      <div className="detail-row">
        <span className="detail-label">Номер договора:</span>
        <span className="detail-value">№ {contract.serial}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">External ID:</span>
        <span className="detail-value">{contract.external_id}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Тип:</span>
        <span className="detail-value">{contract.type}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Предмет договора:</span>
        <span className="detail-value">{contract.subject_type}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Дата заключения:</span>
        <span className="detail-value">{new Date(contract.date).toLocaleDateString('ru-RU')}</span>
      </div>
      {contract.date_end && (
        <div className="detail-row">
          <span className="detail-label">Дата окончания:</span>
          <span className="detail-value">{new Date(contract.date_end).toLocaleDateString('ru-RU')}</span>
        </div>
      )}
      <div className="detail-row">
        <span className="detail-label">Сумма:</span>
        <span className="detail-value"><strong>{contract.amount} ₽</strong></span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Клиент (External ID):</span>
        <span className="detail-value">{contract.client_external_id}</span>
      </div>
      <div className="detail-row">
        <span className="detail-label">Подрядчик (External ID):</span>
        <span className="detail-value">{contract.contractor_external_id}</span>
      </div>
      {contract.comment && (
        <div className="detail-row">
          <span className="detail-label">Комментарий:</span>
          <span className="detail-value">{contract.comment}</span>
        </div>
      )}
      {contract.parent_contract_external_id && (
        <div className="detail-row">
          <span className="detail-label">Родительский договор:</span>
          <span className="detail-value">{contract.parent_contract_external_id}</span>
        </div>
      )}
    </div>
  );
};

// Форма добавления/редактирования договора (с загрузкой контрагентов и справочников)
export const EditContractForm = ({ contract, mode, onSave, onCancel }) => {
  const API_BASE = '/api';
  
  // Получаем userId из localStorage
  const getUserId = () => {
    try {
      const userData = localStorage.getItem('user_data');
      if (userData) {
        return JSON.parse(userData).id || 1;
      }
    } catch (e) {
      console.error('Ошибка получения user_id:', e);
    }
    return 1;
  };
  const userId = getUserId();

  const [formData, setFormData] = useState({
    serial: contract?.serial || '',
    type: contract?.type || 'service',
    comment: contract?.comment || '',
    client_external_id: contract?.client_external_id || '',
    contractor_external_id: contract?.contractor_external_id || '',
    subject_type: contract?.subject_type || 'distribution',
    action_type: contract?.action_type || '',
    date: contract?.date ? contract.date.split('T')[0] : '',
    date_end: contract?.date_end ? contract.date_end.split('T')[0] : '',
    amount: contract?.amount || '',
    parent_contract_external_id: contract?.parent_contract_external_id || '',
    external_id: contract?.external_id || "",
    flags: contract?.flags || []
  });

  const [counterparties, setCounterparties] = useState([]);
  const [subjectTypes, setSubjectTypes] = useState([
    {code: 'distribution', name: 'Распространение рекламы'},
    {code: 'production', name: 'Производство'},
    {code: 'intermediary', name: 'Посредничество'},
    {code: 'representation', name: 'Представительство'},
    {code: 'organization', name: 'Организация распространения'},
    {code: 'other', name: 'Иное'}
  ]);

  useEffect(() => {
    loadCounterparties();
    loadSubjectTypes();
  }, []);

  const loadCounterparties = async () => {
    try {
      const res = await api.get('/counterparties/');
      setCounterparties(res.data);
    } catch (error) {
      console.error('Ошибка загрузки контрагентов:', error);
    }
  };

  const loadSubjectTypes = async () => {
    try {
      const res = await api.get('/dictionaries/subject-types');
      if (res.data.items && res.data.items.length > 0) {
        setSubjectTypes(res.data.items);
      }
    } catch (error) {
      console.error('Ошибка загрузки предметов договора:', error);
    }
  };

  const getCounterpartyName = (external_id) => {
    const cp = counterparties.find(c => c.external_id === external_id);
    return cp ? cp.name || external_id : external_id;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleFlagChange = (e) => {
    const { checked } = e.target;
    const flag = 'contractor_is_creatives_reporter';
    setFormData(prev => ({
      ...prev,
      flags: checked
        ? [...(prev.flags || []), flag]
        : (prev.flags || []).filter(f => f !== flag)
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Валидация обязательных полей
    if (!formData.type) {
      alert('⚠️ Необходимо выбрать "Тип" договора!\n\nВыберите тип и попробуйте снова.');
      return;
    }

    if (!formData.client_external_id || !formData.client_external_id.trim()) {
      alert('⚠️ Необходимо выбрать "Заказчик"!\n\nВыберите заказчика и попробуйте снова.');
      return;
    }

    if (!formData.contractor_external_id || !formData.contractor_external_id.trim()) {
      alert('⚠️ Необходимо выбрать "Исполнитель"!\n\nВыберите исполнителя и попробуйте снова.');
      return;
    }

    if (!formData.subject_type) {
      alert('⚠️ Необходимо выбрать "Предмет договора"!\n\nВыберите предмет договора и попробуйте снова.');
      return;
    }

    if (!formData.date || !formData.date.trim()) {
      alert('⚠️ Необходимо указать "Дату заключения"!\n\nУкажите дату и попробуйте снова.');
      return;
    }

    // External ID больше не обязателен при создании

    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="contract-form">
      <div className="form-row-split">
        <label>
          Серийный номер
          <input 
            type="text" 
            name="serial" 
            value={formData.serial}
            onChange={handleChange}
            placeholder="19"
          />
        </label>

        <label>
          Тип *
          <select name="type" value={formData.type} onChange={handleChange} required>
            <option value="service">Оказание услуг</option>
            <option value="direct">Прямой</option>
            <option value="general">Общий</option>
            <option value="agency">Агентский</option>
          </select>
        </label>
      </div>

      <div className="form-row-split comment-row">
        <label className="comment-label">
          Комментарий к договору
          <textarea 
            name="comment" 
            value={formData.comment}
            onChange={handleChange}
            placeholder="Дополнительная информация"
            rows="1"
            className="form-input comment-textarea"
          />
        </label>
      </div>

      <div className="form-row-split">
        <label>
          Заказчик *
          <select 
            name="client_external_id" 
            value={formData.client_external_id}
            onChange={handleChange}
            required
          >
            <option value="">Выберите заказчика</option>
            {counterparties.map(cp => (
              <option key={cp.external_id} value={cp.external_id}>
                {cp.name}
              </option>
            ))}
          </select>
        </label>

        <label>
          Исполнитель *
          <select 
            name="contractor_external_id" 
            value={formData.contractor_external_id}
            onChange={handleChange}
            required
          >
            <option value="">Выберите исполнителя</option>
            {counterparties.map(cp => (
              <option key={cp.external_id} value={cp.external_id}>
                {cp.name}
              </option>
            ))}
          </select>
        </label>
      </div>

      <div className="form-row-split">
        <label>
          Предмет договора *
          <select name="subject_type" value={formData.subject_type} onChange={handleChange} required>
            {subjectTypes.map(st => (
              <option key={st.code} value={st.code}>{st.name}</option>
            ))}
          </select>
        </label>

        <label>
          Осуществляемые действия
          <input 
            type="text" 
            name="action_type" 
            value={formData.action_type}
            onChange={handleChange}
            placeholder="Выберите осуществляемые действия"
          />
        </label>
      </div>

      <div className="form-row-split">
        <label>
          Дата заключения *
          <input 
            type="date" 
            name="date" 
            value={formData.date}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Дата окончания (если есть)
          <input 
            type="date" 
            name="date_end" 
            value={formData.date_end}
            onChange={handleChange}
            placeholder="дд.мм.гггг"
          />
        </label>
      </div>

      <div className="form-row-with-toggle">
        <div className="amount-section">
        <label>
          Сумма, ₽ (включая все налоги)
          <input 
            type="number" 
            name="amount" 
            value={formData.amount}
            onChange={handleChange}
            min="0"
            step="0.01"
            placeholder="5000"
              className="form-input"
          />
        </label>
      </div>

        <div className="toggle-section">
          <label className="toggle-label">
            <span className="toggle-text">Подрядчик обязуется вести учёт креативов</span>
            <div className="toggle-switch">
              <input 
                type="checkbox" 
                id="contractor-toggle"
                checked={formData.flags?.includes('contractor_is_creatives_reporter')} 
                onChange={handleFlagChange}
              />
              <span className="toggle-slider"></span>
            </div>
        </label>
        </div>
      </div>

      <div className="form-section-title" style={{marginTop: '24px', marginBottom: '16px', color: '#586069', fontSize: '14px'}}>
        Дополнительно
      </div>

      {mode === 'edit' && (
        <>
          <div className="info-row">
            <span className="info-label">External ID</span>
            <span className="info-value">{contract.external_id}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Клиент (External ID)</span>
            <span className="info-value">{contract.client_external_id}</span>
          </div>
          <div className="info-row">
            <span className="info-label">Подрядчик (External ID)</span>
            <span className="info-value">{contract.contractor_external_id}</span>
          </div>
        </>
      )}

      {mode === 'add' && (
        <div className="form-row">
          <label>
            External ID
            <input 
              type="text" 
              name="external_id" 
              value={formData.external_id}
              onChange={handleChange}
              placeholder="Уникальный идентификатор"
            />
          </label>
        </div>
      )}

      <div className="form-row">
        <label>
          Родительский договор (External ID)
          <input 
            type="text" 
            name="parent_contract_external_id" 
            value={formData.parent_contract_external_id}
            onChange={handleChange}
            placeholder="Для подчиненных договоров"
          />
        </label>
      </div>

      <div className="form-actions">
        <button type="button" className="btn-cancel" onClick={onCancel}>
          Отмена
        </button>
        <button type="submit" className="btn-save">
          💾 Сохранить
        </button>
      </div>
    </form>
  );
};
